import React from 'react';
import PropTypes from 'prop-types';
import './RecordCollectionKeywords.css'
import { Badge, Col, Container, Row } from 'react-bootstrap';
import FormElementHeader from '../form/FormElementHeader';
import { useTranslation } from 'react-i18next';

const RecordCollectionKeywords = ({ id, collection }) => {
  const { t } = useTranslation();
  const keywords = collection?.keywords || [];

  return (
    <Container>
      <Row>
        <Col>
          <FormElementHeader
            id={id}
          >
            {t('record_collection_keywords_header')}
          </FormElementHeader>
          <ul className="new-record-collection-keywords">
            {keywords.map(keyword => (
              <li key={keyword.id}>
                <Badge className="record-tag record-collection-keyword-tag" bg="dark">
                  {keyword.label}
                </Badge>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </Container>
  );

};

RecordCollectionKeywords.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  collection: PropTypes.object
};

export default RecordCollectionKeywords;